import type { TFunction } from "i18next";

import { getFieldKindStrategy } from "features/shared/lib/technical-config-tab/fieldKindStrategies";
import { getTableTypicalColumn } from "utils/components";

import type { ShadingSystemCatalogItem, WindowCatalogItem } from "../model/types";

import { getShadingLocationDisplayName } from "./windowConfigOptions";

const catalogValueClassName = "font-ds-body-regular-xs";

const getNumberCatalogCell = (t: TFunction, value: null | number | undefined) =>
  getFieldKindStrategy("number").formatCatalogValue(value, t);

export const getWindowTypePoolTableHeaders = (t: TFunction) => [
  getTableTypicalColumn({
    dataKey: "windowTypeName",
    label: String(t("TechnicalData.windows.poolColumns.name")),
    valueClassName: catalogValueClassName,
  }),
  getTableTypicalColumn({
    dataKey: "frameTypeName",
    label: String(t("TechnicalData.windows.columns.frameType")),
    valueClassName: catalogValueClassName,
  }),
  getTableTypicalColumn({
    dataKey: "uValue",
    label: String(t("TechnicalData.windows.fields.uValue")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: WindowCatalogItem) => getNumberCatalogCell(t, row.uValue),
  }),
  getTableTypicalColumn({
    dataKey: "gValueWindow",
    label: String(t("TechnicalData.windows.fields.gValueWindow")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: WindowCatalogItem) => getNumberCatalogCell(t, row.gValueWindow),
  }),
  getTableTypicalColumn({
    dataKey: "gValueDirectWindow",
    label: String(t("TechnicalData.windows.fields.gValueDirectWindow")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: WindowCatalogItem) => getNumberCatalogCell(t, row.gValueDirectWindow),
  }),
  getTableTypicalColumn({
    dataKey: "gValueDiffuseWindow",
    label: String(t("TechnicalData.windows.fields.gValueDiffuseWindow")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: WindowCatalogItem) => getNumberCatalogCell(t, row.gValueDiffuseWindow),
  }),
];

export const getShadingTypePoolTableHeaders = (t: TFunction) => [
  getTableTypicalColumn({
    dataKey: "shadingSystemType",
    label: String(t("TechnicalData.windows.fields.shadingSystemType")),
    valueClassName: catalogValueClassName,
  }),
  getTableTypicalColumn({
    dataKey: "windowTypeName",
    label: String(t("TechnicalData.windows.poolColumns.name")),
    valueClassName: catalogValueClassName,
  }),
  getTableTypicalColumn({
    dataKey: "location",
    label: String(t("TechnicalData.windows.fields.shadingLocation")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: ShadingSystemCatalogItem) =>
      getShadingLocationDisplayName(row.location, String(t("TechnicalData.windows.fields.shadingLocationNone"))),
  }),
  getTableTypicalColumn({
    dataKey: "radiationTransitionDirect",
    label: String(t("TechnicalData.windows.fields.gValueDirectWindow")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: ShadingSystemCatalogItem) => getNumberCatalogCell(t, row.radiationTransitionDirect),
  }),
  getTableTypicalColumn({
    dataKey: "radiationTransitionDiffuse",
    label: String(t("TechnicalData.windows.fields.gValueDiffuseWindow")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: ShadingSystemCatalogItem) => getNumberCatalogCell(t, row.radiationTransitionDiffuse),
  }),
  getTableTypicalColumn({
    dataKey: "cutOffWindGust",
    label: String(t("TechnicalData.windows.fields.maxWindAverage")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: ShadingSystemCatalogItem) => getNumberCatalogCell(t, row.cutOffWindGust),
  }),
  getTableTypicalColumn({
    dataKey: "cutOffWindSpeed",
    label: String(t("TechnicalData.windows.fields.maxWindExtreme")),
    valueClassName: catalogValueClassName,
    valueTransformation: (row: ShadingSystemCatalogItem) => getNumberCatalogCell(t, row.cutOffWindSpeed),
  }),
];
